
define('C25.Categories.View'
	, [
		'CustomContentType.Base.View'

		, 'c25_categories.tpl'

		, 'jQuery'
		, 'underscore'

		, 'Tools'
	]
	, function (
		CustomContentTypeBaseView

		, c25_categories_tpl

		, jQuery
		, _

		, Tools
	) {
		'use strict';

		return CustomContentTypeBaseView.extend({

			template: c25_categories_tpl
			,
			initialize: function () {
				
			}
			, getContext: function getContext() {
			
				var categories = SC.CATEGORIES;

				var buttons = [];
				if (categories) {
					var category;
					var images = {
						"Warewashing": "/site/sca/img/categories/warewashing.svg",
						// "Coffee": "/site/sca/img/categories/pro-cat2.svg",
						"Refrigeration": "/site/sca/img/categories/refridgeration.svg",
						"Cooking": "/site/sca/img/categories/cooking.svg",
						"Ancillaries / Tools": "/site/sca/img/categories/pro-cat5.svg",
						"Ancillaries": "/site/sca/img/categories/pro-cat5.svg",
						"Parts Books": "/site/sca/img/categories/PartsBookIcon.svg",
						"Van Stock": "/site/sca/img/categories/VanStock.svg"
					};

					for (var i = 0; i < categories.length; i++) {
						if (categories[i].categories.length == 0) {
							category = categories[i];
							if (images[category.name]) {
								category.homeimage = images[category.name];
								buttons.push(category);
							}
						} else {
							for (var j = 0; j < categories[i].categories.length; j++) {
								category = categories[i].categories[j];
								
								if (images[category.name]) {
									category.homeimage = images[category.name];
									buttons.push(category);
									if (category.name == "Ancillaries / Tools") {
										category.name = "Ancillaries";
									}
								}

							}
						}
					}
				}

this.settings.buttons=buttons;
				return this.settings;
			}
		});
	});
